/* global util */

// eslint-disable-next-line no-var
var LoginForm = function () {
  // TODO rework currentStep. In some places its an int, in others a jquery ele
  let currentStep;
  let currentStepId;
  const showClass = "show";
  let hasFieldError = false;
  let isAuthVerificationFlow = false;
  const usernameVerificationForm = 'rh-username-verification';
  const passwordVerificationForm = 'rh-password-verification';
  const authFlowSelectionForm = 'rh-auth-flow-verification';

  this.init = function (form, err, step, accessCode, tabId, clientId) {
    currentStepId = '#' + step;
    currentStep = $(currentStepId);
    shiftSlideInContainer(step === passwordVerificationForm ? 1 : 0);

    if (window.history.pushState) {
      window.history.replaceState({step: step}, null, null);
      window.addEventListener('popstate', function() {
        // showStep(e.state.step);
      });
    }

    $("#login-show-step2").on('click tap dbltap longtap', function(e) {
      e.preventDefault();
      const username = $('#username-verification');
      const usernameErrorSpan = $('#username-verification-error');
      util.hideFormErrorMessage();
      util.hideFieldErrorMessage(username, usernameErrorSpan);
      if (hasFieldError) {
        hasFieldError = false
      }
      if ($('#rh-username-verification').hasClass(showClass)) {
        if (username.val() === '') {
          hasFieldError = true;
          util.showFieldErrorMessage(username, usernameErrorSpan, username.attr('data-msg-required'));
          return;
        }
        validateUsernameOrEmail(username, accessCode, tabId, clientId);
      }
    });

    $('#rh-login-flow').on('click tap dbltap longtap', function() {
      util.setUsernameToSession($('#username-verification').val())
      showStep(passwordVerificationForm);
    });

    // Edit email
    $('#rh-pw-edit-username, #rh-af-edit-username').on('click tap dbltap longtap', function(e) {
      // hide a timeout error message in the event that it has been tripped previously
      util.clearTimeoutError();
      $("#login-show-step2").prop('disabled', false).text($("#login-show-step2").data("textStatic"));

      e.preventDefault();
      const showAuthFlow = currentStep.attr('id') === passwordVerificationForm && isAuthVerificationFlow;
      showStep(showAuthFlow ? authFlowSelectionForm : usernameVerificationForm);
    });
    util.addPasswordToggle();

    // if an error occurs be sure to reset the focus on the password input
    if(err.length > 0 && $("#password").length > 0){
      setTimeout(function(){ $("#password").focus(); }, 600);
    }

    form.submit(function( e ) {
      const password = $('#password');
      const passwordSpan = $('#password-error');
      const submitButton = document.getElementById('rh-password-verification-submit-button');
      util.hideFormErrorMessage();
      util.hideFieldErrorMessage(password, passwordSpan);
      if (hasFieldError) {
        hasFieldError = false
      }
      if (!util.isPasswordVerificationFormValid()) {
        e.preventDefault();
        util.showFieldErrorMessage(password, passwordSpan, password.attr('data-msg-required'));
        submitButton.removeAttribute('disabled');
        // eslint-disable-next-line no-undef
        formPreviouslySubmitted=false;
        hasFieldError = true;
        return false;
      }
      $('#rh-password-verification-submit-button').prop('disabled', 'true').val($('#rh-password-verification-submit-button').data('valueProcessing'));
      // eslint-disable-next-line no-undef
      sendFormSubmissionEvent('login', 'Log In-' + rhd.config.website_current, form[0]);
    });

    $("#password").keydown(function (e) {
      if (e.keyCode === 13) {
        // e.preventDefault();
        form.submit();
      }
    });
      
    if (err && err.length > 0) {
      // hard coding form id since we are using two separate forms now. 
      // eslint-disable-next-line no-undef
      sendFormErrorsArrayEvent('rh-password-verification-form', 'login', 'Log In-' + rhd.config.website_current, err);
    } else {
      // hard coding form id since we are using two separate forms now. 
      // eslint-disable-next-line no-undef
      sendFormLoadEvent('rh-password-verification-form', 'login', 'Log In-' + rhd.config.website_current);
    }
  };

  // eslint-disable-next-line no-var
  var validateUsernameOrEmail = function (username, accessCode, tabId, clientId) {
    // Very important to DO NOT validate on submit.
    // Vadliation is only for validating username and in case of 503 on REST API it's important to allow submit
    $.ajax({
      // eslint-disable-next-line no-undef
      url: "/auth/realms/redhat-external/rhdtools/v3/loginOptions",
      method: "post",
      cache: false,
      contentType: "application/json",
      data: JSON.stringify(
        {
          username: username.val(),
          accessCode: accessCode,
          tabId: tabId,
          clientId: clientId
        }
      ),
      error: function (jqXHR, textStatus, errorThrown) {
        if (jqXHR && jqXHR.status === 403) {
          // Do not reload because REST API returns 403 too early
          // location.reload();
          const formErrorDiv = $('#rh-login-form-alert');
          util.showFormErrorMessage(formErrorDiv.data('access-denied-title'), formErrorDiv.data('access-denied-body'));
        } else {
          window.location.href += "&timeout=1";
        }
      },
      beforeSend: function () {
        $('#username-verification').prop('readonly', true);
        $("#login-show-step2").prop('disabled', 'true').text($("#login-show-step2").data("textProcessing"));
      },
      complete: usernameValidationFinished
    })
  };

  // eslint-disable-next-line no-var
  var usernameValidationFinished = function(jqXHR) {
    if (jqXHR && jqXHR.status === 403) {
      // Do not reload because REST API returns 403 too early
      // location.reload();
      const formErrorDiv = $('#rh-login-form-alert');
      util.showFormErrorMessage(formErrorDiv.data('access-denied-title'), formErrorDiv.data('access-denied-body'));
      return;
    }
    const username = $("#username-verification");
    const response = JSON.parse(jqXHR.responseText);
    // reset variables
    isAuthVerificationFlow = false;
    if (response.idp.length > 1) {
      showStep(authFlowSelectionForm);
      setAuthVerificationFlow(response);
    }
    else if (response.idp.length === 1) {
      isAuthVerificationFlow = response.formAuth
      const idpLink = response.idp[0].idpLoginUrl
      if (isAuthVerificationFlow) {
        $('#rh-sso-flow').on('click tap dbltap longtap', function() {
          $('#rh-sso-flow').prop('disabled', 'true');
          util.setUsernameToSession($('#username-verification').val())
          window.location = idpLink;
        });
        showStep(authFlowSelectionForm);
        setAuthVerificationFlow(response);
      } else {
        util.setUsernameToSession($('#username-verification').val())
        window.location = idpLink;
      }
    } 
    else {
      setPasswordVerificationFlow();
      showStep(passwordVerificationForm);
    }
    updateUsernameFields(username.val());
    $('#username-verification').prop('readonly', false);
    // TODO: Add error handling for unsuccessful network request
  };
  
  const updateHistory = function(step) {
    if (window.history.pushState) {
      window.history.pushState({step: step}, null, null);
    }
  }

  // eslint-disable-next-line no-var
  var showStep = function(step) {
    const stepId= '#' + step;
    // eslint-disable-next-line no-shadow, @typescript-eslint/no-shadow
    const currentStepId = currentStep.attr('id');
    updateHistory(step);
    if (step === usernameVerificationForm) {
      handleSlideIn(stepId, 0);
      util.hideFormErrorMessage();
      const usernameVer = document.getElementById("username-verification")
      usernameVer.setAttribute("aria-invalid", false);
      document.getElementById("password").setAttribute("aria-invalid", false);
      // ensure that the username field can always be edited in this stage
      usernameVer.readOnly = false;
      // trigger after a delay.
      setTimeout(function(){ 
        updateUsernameFields("");
        usernameVer.focus();
      }, 600);
          
    } else if (step === authFlowSelectionForm) {
      handleSlideIn(stepId, 1);
    }
    else if (step === passwordVerificationForm) {
      const direction = currentStepId === usernameVerificationForm ? 1 : 2;
      updatePasswordResetLink();
      handleSlideIn(stepId, direction);
      setTimeout(function(){ $("#password").focus(); }, 600);
    }
  };

  // eslint-disable-next-line no-var
  var updateUsernameFields = function(value) {
    document.getElementById("username-verification").value = value;
    document.getElementById("username").value = value;
    document.getElementById("rh-af-username").value = value
  }

  // eslint-disable-next-line no-var
  var handleSlideIn = function(nextStepId, step) {
    const nextStep = $(nextStepId); // update when reworking 'currentStep'
    if (typeof step === 'number' && nextStep) {
      toggleShowClass(currentStep, nextStep);
      shiftSlideInContainer(step);
      toggleTabIndex(currentStepId, nextStepId);
      currentStepId = nextStepId;
      currentStep = nextStep;
    }
  }
  // handles moving the container to display the correct form
  // eslint-disable-next-line no-var
  var shiftSlideInContainer = function(direction) {
    const slideInContainer = document.getElementById("rh-login-slide-in-container");
    const width = slideInContainer.offsetWidth /3  * direction;

    slideInContainer.style.transform = "translateX(-" + width + "px)";
  }
  
  // eslint-disable-next-line no-var
  var toggleShowClass = function(stepToDisable, stepToEnable) {
    stepToEnable.addClass(showClass);
    stepToDisable.removeClass(showClass);
  }

  // TODO: Figure out if tabindex needs to be updated 
  // eslint-disable-next-line no-var, no-shadow, @typescript-eslint/no-shadow
  var toggleTabIndex = function (currentStepId, nextStepId) {
    getFormInputs(nextStepId).removeAttr('tabindex');
    getFormInputs(currentStepId).attr('tabindex', '-1');
  }

  // eslint-disable-next-line no-var
  var updatePasswordResetLink = function() {
    const resetPasswordLink = $("#reset-password");
    const username = $('#username-verification').val();
    if (resetPasswordLink.length) {
      let resetPwdUrl = resetPasswordLink.attr('href');
      resetPwdUrl = util.updateQueryStringParameter(resetPwdUrl, "un", encodeURIComponent(username));
      resetPasswordLink.attr('href', resetPwdUrl);
    }
  }

  // eslint-disable-next-line no-var
  var getFormInputs = function(parentSelector) {
    return $('input, select, a, button', parentSelector);
  };

  // provided an array of idp objects, this function generates a series of buttons to allow the user 
  // to select the desired idp 
  // eslint-disable-next-line no-var
  var generateIDPOptions = function (idpInfo) {
    const destinationDiv = document.getElementById("multiIDPFlow");
    // clear it in case it already exists
    destinationDiv.innerHTML = '';
    idpInfo.idp.forEach( idprov => {
      const newButton = document.createElement("button");
      newButton.setAttribute("type", "button");
      newButton.setAttribute("class", "pf-c-button pf-m-secondary rh-auth-flow-selection-button");
      newButton.setAttribute("id", idprov.alias + "-button");
      newButton.innerText = "Log in with " + idprov.displayName;
      newButton.addEventListener("click", () => {
        util.setUsernameToSession($('#username-verification').val());
        window.location = idprov.idpLoginUrl;
      });

      destinationDiv.appendChild(newButton);
    });

    if(idpInfo.formAuth){
      const rhButton = document.createElement("button");
      rhButton.setAttribute("type", "button");
      rhButton.setAttribute("class", "pf-c-button pf-m-secondary rh-auth-flow-selection-button");
      rhButton.setAttribute("id", "rh-login-flow");
      rhButton.innerText = "Log in with Red Hat";
      rhButton.addEventListener("click", () => {
        util.setUsernameToSession($('#username-verification').val())
        showStep(passwordVerificationForm);
      });
      destinationDiv.appendChild(rhButton);
    }
  }


  // Set the order of flex items to match flow (username -> auth (3rd party login or rhd/password login))
  // eslint-disable-next-line no-var
  var setAuthVerificationFlow = function(userIDPInfo) {

    const mutliFlowDiv = document.getElementById("multiIDPFlow");
    const binaryFlowDiv = document.getElementById("binaryIDPFlow");

    if(userIDPInfo.formAuth && userIDPInfo.idp.length === 1){
      binaryFlowDiv.style.display = "inherit";
      mutliFlowDiv.style.display = "none";
    } else{
      binaryFlowDiv.style.display = "none";
      mutliFlowDiv.style.display = "inherit";
      generateIDPOptions(userIDPInfo);
    }

    $('#rh-password-verification').css({order: 3});
    $('#rh-auth-flow-verification').css({order: 2});
  }
  // Set the order of flex items to match flow (username -> password)
  // eslint-disable-next-line no-var
  var setPasswordVerificationFlow = function() {
    $('#rh-password-verification').css({order: 2});
    $('#rh-auth-flow-verification').css({order: 3});
  }

}
// eslint-disable-next-line no-var, no-unused-vars
var loginForm = new LoginForm();
